import { render, staticRenderFns } from "./OtherAgency.vue?vue&type=template&id=46c0ae96&"
import script from "./OtherAgency.vue?vue&type=script&lang=js&"
export * from "./OtherAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports